(function() {
	'use strict';

	angular.module('smb-app')
		.directive('smbDocumentHitList', DocumentHitListDirective)
		.controller('smbDocumentHitListController', ['smbDocumentViewerNavigationService', DocumentHitListController]);

	var templateUrl = require('./documentHitList.template');
	function DocumentHitListDirective() {
		return {
			restrict: 'E',
			controller: 'smbDocumentHitListController',
			controllerAs: 'vm',
			templateUrl: templateUrl,
			bindToController: true,
			scope: {
				viewOnSelect: '=',
				documents: '=',
				onSelectDocument: '&'
			}
		};
	}

	function DocumentHitListController(smbDocumentViewerNavigationService) {
		var vm = this;
		vm.onClick = onClick;

		function onClick(document) {
			vm.onSelectDocument({ document: document });
			if (vm.viewOnSelect) {
				smbDocumentViewerNavigationService.go(document.LibraryId, document.FolderId, document.DocumentId);
			}
		}

	}
}());


//////////////////
// WEBPACK FOOTER
// ./app/components/documentHitList/documentHitList.js
// module id = 82
// module chunks = 1